import {useSelector} from 'react-redux'

import {getPasswordlessLoginSourceComponent} from '@vio/core/src/auth/modules/selectors'
import {paymentPageSourceComponents} from '@vio/core/src/auth/types/Auth'

/**
 * Whether SUSI was opened from the payment page, via the login banner or the
 * header sign in.
 */
export const useIsPaymentPageSignIn = () => {
  const sourceComponent = useSelector(getPasswordlessLoginSourceComponent)

  return paymentPageSourceComponents.includes(sourceComponent ?? '')
}
